import React, { useEffect, useState } from 'react';
import axios from '../axiosConfig';
import '../css/modalPerfil.css';
import { handleError, toastError, toastSuccess } from '../funciones';
import BtnGuardarEdit from './BtnGuardarEdit';
import DatosRepresentante from './DatosRepresentante';
import EditarBorrarRepresentante from './EditarBorrarRepresentante';
import FormEditInput from './FormEditInput';
import OfertaDemanda from './OfertaDemanda';

function EditarPerfil(props){

    const [badgesRubro, setBadgesRubro]=useState([]); 
    const [badgesOferta, setBadgesOferta]=useState([]); 
    const [badgesDemanda, setBadgesDemanda]=useState([]); 
    const [representantes, setRepresentantes]=useState([]);
    const [representantesAgregados, setRepresentantesAgregados]=useState([]);
    const [representantesEliminados, setRepresentantesEliminados]=useState([]);
    //const [cantRepresentantes, setCantRepresentantes]=useState(1);
    const [perfilEditado, setPerfilEditado]=useState({rubros:[],rubrosSinFormato:[],productosOfrecidos:[],productosDemandados:[], representantes:[]});
    const idBoxZona = [['descripcionEmpresaEditar'], ['nombreInput', 'calleInput', 'alturaInput', 'localidadInput', 'codigoPostalInput',
        , 'emailInput', 'telefonoInput']]; 
    
        function guardar(zonaGuardar){
        const params = props.perfil; 
        var params2 = {}; 
        var pagWeb = document.getElementById("paginaInput").value;
        if(pagWeb === ""){
            pagWeb = "No posee"
        }
        params2.descripcion = document.getElementById("descripcionEmpresaEditar").value;
        params2.nombre = document.getElementById("nombreInput").value;
        params2.calle = document.getElementById("calleInput").value;
        params2.altura = document.getElementById("alturaInput").value;
        params2.localidad = document.getElementById("localidadInput").value;
        params2.codigoPostal = document.getElementById("codigoPostalInput").value;
        params2.paginaWeb = pagWeb;
        params2.email = document.getElementById("emailInput").value;
        params2.numeroDeTelefono = document.getElementById("telefonoInput").value;  
        let productosOfrecidos = []; 
        let productosDemandados = []; 
        let rubros = []; 
        let rubrosSinFormato = []; 
        badgesOferta.forEach(e => {productosOfrecidos.push(e.label)})
        badgesDemanda.forEach(e => {productosDemandados.push(e.label)})
        badgesRubro.forEach(e => {rubros.push(e.label)})
        badgesRubro.forEach(e => {rubrosSinFormato.push(e.value)})
        params2.rubros = rubros;
        params2.productosDemandados = productosDemandados;
        params2.productosOfrecidos = productosOfrecidos;  
        params2.rubrosSinFormato = rubrosSinFormato;  
        setPerfilEditado(params2);
        if(permitirModificar(zonaGuardar)){
            if(zonaGuardar === 0){
                params.descripcion = document.getElementById("descripcionEmpresaEditar").value;
            }else if(zonaGuardar === 1){
                params.nombre = document.getElementById("nombreInput").value;
                params.calle = document.getElementById("calleInput").value;
                params.altura = document.getElementById("alturaInput").value;
                params.localidad = document.getElementById("localidadInput").value;
                params.codigoPostal = document.getElementById("codigoPostalInput").value;
                params.paginaWeb = pagWeb;
                params.email = document.getElementById("emailInput").value;
                params.numeroDeTelefono = document.getElementById("telefonoInput").value;  
            }else if(zonaGuardar === 2){
                let productosOfrecidos = []; 
                let productosDemandados = []; 
                let rubros = []; 
                let rubrosSinFormato = []; 
                badgesRubro.forEach(e => {rubros.push(e.label)})
                badgesRubro.forEach(e => {rubrosSinFormato.push(e.value)})
                if(badgesDemanda.length !== 0)
                    badgesDemanda.forEach(e => {productosDemandados.push(e.label)})
                else
                    productosDemandados.push('');
                if(badgesOferta.length !== 0)
                    badgesOferta.forEach(e => {productosOfrecidos.push(e.label)})
                else
                    productosOfrecidos.push('');
                params.rubros = rubros;
                params.productosDemandados = productosDemandados;
                params.productosOfrecidos = productosOfrecidos;  
                params.rubrosSinFormato = rubrosSinFormato;  
            }else if(zonaGuardar === 3){
                let representantesNuevo = []; 
                representantesAgregados.forEach(e => {representantesNuevo.push({apellido: e.apellido, nombre: e.nombre, cargo: e.cargo, eliminado: false})})
                
                representantes.map((x, i) => {
                    const apellido = document.getElementById("apellidoEditText" + (x.id)).value;
                    const nombre = document.getElementById("nombreEditText" + (x.id)).value;
                    const cargo = document.getElementById("cargoEditText" + (x.id)).value;
                    if(!(!apellido || !nombre || !cargo)){
                        representantesNuevo.push({id:x.id, apellido: apellido, nombre: nombre, cargo:cargo, eliminado: false})
                    }
                })
                representantesEliminados.map((x, i) => {
                    representantesNuevo.push(x)
                })
                params.representantes = representantesNuevo;
            }else{
                params.descripcion = document.getElementById("descripcionEmpresaEditar").value;
                params.nombre = document.getElementById("nombreInput").value;
                params.calle = document.getElementById("calleInput").value;
                params.altura = document.getElementById("alturaInput").value;
                params.localidad = document.getElementById("localidadInput").value;
                params.codigoPostal = document.getElementById("codigoPostalInput").value;
                params.paginaWeb = pagWeb;
                params.email = document.getElementById("emailInput").value;
                params.numeroDeTelefono = document.getElementById("telefonoInput").value;  
                let productosOfrecidos = []; 
                let productosDemandados = []; 
                let rubros = []; 
                let rubrosSinFormato = []; 
                if(badgesDemanda.length !== 0)
                    badgesDemanda.forEach(e => {productosDemandados.push(e.label)})
                else
                    productosDemandados.push('');
                if(badgesOferta.length !== 0)
                    badgesOferta.forEach(e => {productosOfrecidos.push(e.label)})
                else
                    productosOfrecidos.push('');
                badgesRubro.forEach(e => {rubros.push(e.label)})
                badgesRubro.forEach(e => {rubrosSinFormato.push(e.value)})
                params.rubros = rubros;
                params.productosDemandados = productosDemandados;
                params.productosOfrecidos = productosOfrecidos;  
                params.rubrosSinFormato = rubrosSinFormato;  
                let representantesNuevo = []; 
                representantesAgregados.forEach(e => {representantesNuevo.push({apellido: e.apellido, nombre: e.nombre, cargo: e.cargo, eliminado: false})})

                representantes.map((x, i) => {
                    const apellido = document.getElementById("apellidoEditText" + (x.id)).value;
                    const nombre = document.getElementById("nombreEditText" + (x.id)).value;
                    const cargo = document.getElementById("cargoEditText" + (x.id)).value;
                    if(!(!apellido || !nombre || !cargo)){
                        representantesNuevo.push({id:x.id, apellido: apellido, nombre: nombre, cargo:cargo, eliminado: false})
                    }
                })
                representantesEliminados.map((x, i) => {
                    representantesNuevo.push(x)
                })
                params.representantes = representantesNuevo;
            }

            var params3 = { 
                id: params.id,
                descripcion: params.descripcion,
                nombre: params.nombre,
                calle: params.calle, 
                altura: params.altura,
                localidad: params.localidad,
                codigoPostal: params.codigoPostal,
                paginaWeb: params.paginaWeb,
                email: params.email,
                numeroTelefono: params.numeroDeTelefono,
                productosDemandados: params.productosDemandados,
                productosOfrecidos: params.productosOfrecidos, 
                rubros: params.rubrosSinFormato,
                representantes: params.representantes
                
            }
            axios
            .put(process.env.REACT_APP_URL + 'empresa', params3)
            .then((res) => {
                toastSuccess("Cambios Guardados")
                props.setPerfil((params) => {
                    return { ...params, ... params};
                });
                if(zonaGuardar === 1 || zonaGuardar === -1){
                    localStorage.setItem(process.env.REACT_APP_NOMBRE_EMPRESA, params.nombre);
                    localStorage.setItem(process.env.REACT_APP_MAIL_EMPRESA, params.email); 
                    document.getElementById("nombrePerfilNavBar").innerText = params.nombre;  
                }
                if(zonaGuardar === 3 || zonaGuardar === -1)
                {
                    recargarRepresentantes()
                }
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
        }
    }

    function permitirModificar(zonaGuardar){
        var ret = true;
        if(zonaGuardar === -1){
            ret = permitirModificar(0) &&  permitirModificar(1) && permitirModificar(2) && permitirModificar(3); 
        }
        else if(zonaGuardar < 2){
            idBoxZona[zonaGuardar].forEach(e => {
                if(!document.getElementById(e).value){
                    document.getElementById(e).classList.add("texBoxError");
                    ret = false;
                    
                }
            })
            if(!ret){
                if(zonaGuardar === 0)
                    toastError("Debe completar la descripción")
                else
                    toastError("Debe completar los datos de la empresa")
            }
        }
        else if(zonaGuardar === 2){
            if(badgesRubro.length === 0){
                ret = false;
                toastError("Debe seleccionar al menos un rubro")
            }
        }else{
            
            if(representantes.length === 0 && representantesAgregados.length === 0){
                ret = false;
                toastError("Debe ingresar al menos un representante")
            }else{
                representantes.forEach(r => {
                    if(!document.getElementById("nombreEditText" + r.id).value || !document.getElementById("apellidoEditText" + r.id).value
                    || !document.getElementById("cargoEditText" + r.id).value){
                        ret = false;//debe completar todos los datos de los representantes registrados
                        
                    }
                })
                if(!ret)
                    toastError("Debe completar los datos de los representantes registrados");
               
            }


        }
        return ret;
    }

    function recargarRepresentantes(){
    
        if(representantesAgregados.length > 0){
            const params = {
                params:{
                    empresaId: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
                }
            }
            axios.get(process.env.REACT_APP_URL + "empresa/verRepresentantesDeUnaEmpresa", params)
            .then(function (response) {
                setRepresentantes(response.data);
                setRepresentantesAgregados([]);
            })
            .catch(function (error) {
                toastError(handleError(error))
            });
        }
        setRepresentantesEliminados([]);
    }

    function setRepresenElim(id){
        setRepresentantesEliminados(representantesEliminados => [...representantesEliminados, {id: id, eliminado: true }])
    }

    useEffect(() => {
        if(props.guardar !== 1){
            guardar(-1);
        }
        
    },[props.guardar]) 

    useEffect(() => {
        if(perfilEditado.nombre === null || perfilEditado.nombre === undefined || perfilEditado.nombre === '' ){
            setPerfilEditado(props.perfil);
        
        }
    },[props.perfil]) 

    useEffect(() => {
        setBadgesRubro([]);
        setBadgesOferta([]);
        setBadgesDemanda([]);
        perfilEditado.rubrosSinFormato.map(function(elem, i){setBadgesRubro(badgesRubro =>[...badgesRubro, {value:elem, label:props.perfil.rubros[i]}])});
        perfilEditado.productosOfrecidos.map(function(elem, i){if(elem !== ""){setBadgesOferta(badgesOferta =>[...badgesOferta,{value:-i, label:elem}])}});
        perfilEditado.productosDemandados.map(function(elem, i){if(elem !== ""){setBadgesDemanda(badgesDemanda =>[...badgesDemanda,{value:-i, label:elem}])}});
        //setCantRepresentantes(perfilEditado.representantes.length);
        
        if(representantes.length === 0 && perfilEditado.representantes != undefined && perfilEditado.representantes != null)
            setRepresentantes(perfilEditado.representantes)
    },[perfilEditado]) 

    return(  
        <>        
           
           <div className='container pt-3  d-none' id="editarPerfil">
                <div className=' px-2'>
                    <FormEditInput defaultValue={perfilEditado.descripcion}id={"descripcionEmpresaEditar"} className={'row pb-3 px-2'} idSeccion={1}/> 
                    <BtnGuardarEdit zona={0} className={"row text-center py-3"} guardar={guardar} text={"Guardar"}/>
                    <h3 className='letraTituloPerfil py-3 mb-0 me-2'>Datos de la empresa:</h3>
                    <div className='row mt-3 letraDatosPerfil py-3 px-4 mx-0 datosEmpresa'> 
                        <div className='container-fluid'> 
                            <FormEditInput defaultValue={perfilEditado.nombre} text={"Razón social: "} type={"text"} id={"nombreInput"} className={'borderBotRepresentante row align-items-center'}/>                                
                            <div className='row align-items-center'>
                                <FormEditInput defaultValue={perfilEditado.calle} text={"Calle: "} type={"text"} id={"calleInput"} idSeccion={0}/>  
                                <FormEditInput defaultValue={perfilEditado.altura} text={"Altura: "} type={"text"} id={"alturaInput"} idSeccion={0}/>  
                            </div>
                                                    
                            <div className='borderBotRepresentante row align-items-center'>
                                <FormEditInput defaultValue={perfilEditado.localidad} text={"Localidad: "} type={"text"} id={"localidadInput"} idSeccion={0}/>  
                                <FormEditInput defaultValue={perfilEditado.codigoPostal} text={"Código Postal: "} type={"number"} id={"codigoPostalInput"} idSeccion={0}/>  
                            </div>
                            <FormEditInput defaultValue={perfilEditado.paginaWeb} text={"Página web: "} type={"text"} id={"paginaInput"} className={'borderBotRepresentante row align-items-center'} helper={'(Opcional)'}/>  
                            <FormEditInput defaultValue={perfilEditado.email} text={"Email: "} type={"email"} id={"emailInput"} className={'borderBotRepresentante row align-items-center'}/>  
                            <FormEditInput defaultValue={perfilEditado.numeroDeTelefono} text={"Teléfono: "} type={"number"} id={"telefonoInput"} className={'row align-items-center'} helper={'(Sin guiones)'}/>  
                        </div> 
                    </div>
                    <BtnGuardarEdit zona={1} className={"row text-center py-4 my-2"} guardar={guardar} text={"Guardar"}/>
                    <OfertaDemanda setBadgesOferta={setBadgesOferta} badgesOferta={badgesOferta}  
                    badgesDemanda={badgesDemanda}  setBadgesDemanda={setBadgesDemanda} 
                    badgesRubro={badgesRubro} setBadgesRubro={setBadgesRubro}/>
                    <BtnGuardarEdit zona={2} className={"row text-center py-4 my-2"} guardar={guardar} text={"Guardar"}/>
                    <h3 className='letraTituloPerfil py-3 mb-4 me-2'>Datos de los representantes:</h3>
                    <DatosRepresentante representantes={representantesAgregados} 
                    setRepresentantes={setRepresentantesAgregados} text={"Agregar representantes"}/>
                    <EditarBorrarRepresentante representantes={representantes} setRepresenElim={setRepresenElim}
                    setRepresentantes={setRepresentantes} text={"Editar representantes actuales"}/>
                    <BtnGuardarEdit zona={3} className={"row text-center py-4 my-2"} guardar={guardar} text={"Guardar"}/>
                </div>
            </div>        
         
           
        </>
        
    );
}


export default EditarPerfil;